module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0105.jpg?v=82f5b0ae";